export default __webpack_public_path__ + "static/media/No_image_backdrop.386d012a.png";